import { render, staticRenderFns } from "./labelIndex.vue?vue&type=template&id=77bf5fa1"
import script from "./labelIndex.vue?vue&type=script&lang=js"
export * from "./labelIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77bf5fa1')) {
      api.createRecord('77bf5fa1', component.options)
    } else {
      api.reload('77bf5fa1', component.options)
    }
    module.hot.accept("./labelIndex.vue?vue&type=template&id=77bf5fa1", function () {
      api.rerender('77bf5fa1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/categoryLabelManage/labelIndex.vue"
export default component.exports